import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaGlobeAsia, FaEye, FaEyeSlash, FaUserPlus } from 'react-icons/fa';
import { authAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './Auth.css';

const Register = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) { toast.error('Passwords do not match'); return; }
    if (form.password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    setLoading(true);
    try {
      await authAPI.register({ name: form.name, email: form.email, password: form.password });
      toast.success('Account created! Please sign in.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <div className="auth-left-content">
          <div className="auth-brand">
            <div className="auth-brand-icon"><FaGlobeAsia /></div>
            <div>
              <div className="auth-brand-name">Pavishna</div>
              <div className="auth-brand-sub">Global Services</div>
            </div>
          </div>
          <h2>Begin Your International Career Journey Today</h2>
          <p>Create a free account and get instant access to hundreds of verified job openings across the Gulf and Southeast Asia.</p>
          <div className="auth-features">
            <div className="auth-feature">✅ Free to register</div>
            <div className="auth-feature">✅ Verified job listings</div>
            <div className="auth-feature">✅ Direct employer access</div>
            <div className="auth-feature">✅ Expert guidance</div>
          </div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-card">
         <div className="auth-card-header">
  <Link to="/" className="back-home-link">← Back to Home</Link>
  <h1>Create Account</h1>
  <p>Register to explore international job opportunities</p>
</div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Full Name</label>
              <input className="form-control" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required placeholder="Your full name" />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" className="form-control" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required placeholder="your@email.com" />
            </div>
            <div className="form-row-2">
              <div className="form-group">
                <label>Password</label>
                <div className="pass-wrap">
                  <input type={showPass ? 'text' : 'password'} className="form-control" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required placeholder="Min 6 characters" />
                  <button type="button" className="toggle-pass" onClick={() => setShowPass(!showPass)}>
                    {showPass ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label>Confirm Password</label>
                <div className="pass-wrap">
                  <input type="password" className="form-control" value={form.confirmPassword} onChange={e => setForm({...form, confirmPassword: e.target.value})} required placeholder="Repeat password" />
                </div>
              </div>
            </div>
            <button type="submit" className="btn-primary auth-submit" disabled={loading}>
              {loading ? 'Creating Account...' : <><FaUserPlus /> Create Account</>}
            </button>
          </form>

          <div className="auth-footer">
            Already have an account? <Link to="/login">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
